import { render, staticRenderFns } from "./StudentUnits.vue?vue&type=template&id=62af0ae0"
import script from "./StudentUnits.vue?vue&type=script&lang=js"
export * from "./StudentUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports